import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Component, OnInit, Input } from '@angular/core';
import { Store } from '@ngrx/store';

import { QuickstartProgrammingService } from '../../services/quickstart-programming.service';
import { ScheduleProgrammingService } from './../services/schedule.service';
import { SharedProgrammingService } from './../../../common/services/shared-programming.service';
import { ProgrammingUtilsService } from './../../../common/services/utils.service';

@Component({
  selector: 'prg-select-repeat',
  templateUrl: './select-repeat.component.html',
  styleUrls: ['./select-repeat.component.less']
})
export class SelectRepeatComponent implements OnInit {

  @Input() fixRepeating: boolean;

  repeatType: Observable<string>;
  repeatFrequency: Observable<number>;
  repeatRate: Observable<number>;
  endDate: Observable<any>;
  hasEndDate: Observable<boolean>;

  constructor(
    protected store: Store<any>,
    protected utils: ProgrammingUtilsService,
    protected schedule: ScheduleProgrammingService
  ) {
    this.repeatType = this.store.select(s => s.scheduleProgramming.repeatType);
    this.repeatFrequency = this.store.select(s => s.scheduleProgramming.repeatFrequency);
    this.repeatRate = this.store.select(s => s.scheduleProgramming.repeatRate);
    this.endDate = this.store.select(s => s.scheduleProgramming.endDate);
    this.hasEndDate = this.store.select(s => s.scheduleProgramming.hasEndDate);
    this.fixRepeating = false;
  }

  ngOnInit() {
  }

  doesRepeat(repeats: boolean) {
    this.schedule.setRepeatInterval((repeats) ? 1 : 0);
  }

  intervalChanged(event: any) {
    let interval = parseInt(event.target.value);
    this.schedule.setRepeatInterval(interval);
  }

  rateChanged(event: any) {
    let rate = parseInt(event.target.value);
    this.schedule.setRepeatRate(rate);
  }

  isChecked(dow: number): boolean {
    let dayMask = this.utils.getValue(this.store, s => s.scheduleProgramming.repeatDays);
    return this.utils.bitTest(dayMask, dow);
  }

  selectWeekends() {
    this.schedule.batchSelect(65);
  }

  selectWeekdays() {
    this.schedule.batchSelect(62);
  }

  selectAll() {
    this.schedule.batchSelect(127);
  }

  selectNone() {
    this.schedule.batchSelect(0);
  }

  toggleDay(dow: number) {
    this.schedule.toggleRepeatDayOfWeek(dow);
  }

  setEndDate(event: any) {
    this.schedule.setEndDate(event.target.value);
  }

  toggleHasEndDate(event: any) {
    this.schedule.toggleHasEndDate();
  }

  nextClicked() {
  }

  occursChanged(event: any) {
    this.schedule.setRepeatType(event.target.value);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-schedule/select-repeat/select-repeat.component.ts